import React from "react";

const HaltPing = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36", }) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fill={fill || "#640D5F"}
            stroke="#fff"
            strokeWidth={0.909}
            d="M17.818 33.454c1.787 0 3.422-.206 4.625-.55.598-.17 1.115-.383 1.493-.638.362-.245.7-.603.7-1.084 0-.482-.338-.84-.7-1.085-.378-.255-.895-.467-1.493-.638-1.203-.344-2.838-.55-4.625-.55s-3.422.206-4.624.55c-.599.17-1.116.383-1.494.638-.362.245-.7.603-.7 1.085 0 .481.338.84.7 1.084.378.255.895.468 1.494.638 1.202.344 2.837.55 4.624.55Z"
        />
        <path
            fill="#fff"
            stroke="#C8CBD8"
            strokeWidth={0.803}
            d="m26.286 23.286-8.236 8.237-8.237-8.237c-4.549-4.549-4.549-11.924 0-16.473 4.55-4.549 11.924-4.549 16.473 0 4.55 4.55 4.55 11.924 0 16.473Z"
        />
        <path
            fill={fill || "#640D5F"}
            d="M27.897 14.834c0 5.438-4.409 9.847-9.847 9.847-5.439 0-9.847-4.409-9.847-9.847 0-5.439 4.408-9.847 9.847-9.847 5.438 0 9.847 4.408 9.847 9.847Z"
        />
        <path
            stroke="#fff"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.607}
            d="M15.459 14.834h5.182m-5.182-3.628v7.256m5.182-7.256v7.256m-1.036 0h2.073m-2.073-7.256h2.073m-7.256 7.256h2.073m-2.073-7.256h2.073"
        />
    </svg>
);

export default HaltPing;
